// Static map: A2UI component type name → React component

import React from 'react';

import type { A2UIComponentDefinition } from '../types/A2UIComponents.types.tsx';

export type A2UIRendererComponent = React.ComponentType<{
	definition: A2UIComponentDefinition;
	visited?: Set<string>;
}>;

const registry = new Map<string, A2UIRendererComponent>();

export const registerComponent = (type: string, component: A2UIRendererComponent): void => {
	registry.set(type, component);
};

export const getComponent = (type: string): A2UIRendererComponent | undefined => {
	return registry.get(type);
};

// Bulk registration helper — called once at module load from component files
export const registerAllComponents = (components: Record<string, A2UIRendererComponent>): void => {
	for (const [type, component] of Object.entries(components)) {
		registry.set(type, component);
	}
};
